import React from 'react';
import Icon from '../../../components/AppIcon';

const PageEngagementTable = ({ data }) => {
  const formatTime = (seconds) => {
    if (seconds < 60) return `${seconds}s`;
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}m ${remainingSeconds}s`;
  };

  const getEngagementLevel = (avgTime) => {
    if (avgTime >= 300) return { label: 'High', color: 'text-success' };
    if (avgTime >= 120) return { label: 'Medium', color: 'text-accent' };
    return { label: 'Low', color: 'text-warning' };
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="mb-6">
        <h3 className="font-heading font-semibold text-base md:text-lg text-foreground mb-1">
          Screen Engagement Analysis
        </h3>
        <p className="caption text-xs md:text-sm text-muted-foreground">
          Page views and average time spent per screen
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-2 caption text-xs font-medium text-muted-foreground">
                Screen
              </th>
              <th className="text-center py-3 px-2 caption text-xs font-medium text-muted-foreground">
                Views
              </th>
              <th className="text-center py-3 px-2 caption text-xs font-medium text-muted-foreground">
                Avg Time
              </th>
              <th className="text-center py-3 px-2 caption text-xs font-medium text-muted-foreground">
                Engagement
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.slice(0, 8)?.map((page, index) => {
              const engagement = getEngagementLevel(page?.avgTimeSpent);
              return (
                <tr key={index} className="border-b border-border/50 hover:bg-muted/30 transition-smooth">
                  <td className="py-3 px-2">
                    <div className="flex items-center gap-2">
                      <Icon name="Layout" size={16} color="var(--color-muted-foreground)" />
                      <div>
                        <p className="font-heading text-sm font-medium text-foreground">
                          {page?.pageTitle}
                        </p>
                        <p className="caption text-xs text-muted-foreground">
                          {page?.pagePath}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="py-3 px-2 text-center">
                    <span className="data-text text-sm font-medium text-foreground">
                      {page?.totalViews}
                    </span>
                  </td>
                  <td className="py-3 px-2 text-center">
                    <span className="data-text text-sm font-medium text-foreground">
                      {formatTime(page?.avgTimeSpent)}
                    </span>
                  </td>
                  <td className="py-3 px-2 text-center">
                    <span className={`caption text-xs font-medium ${engagement?.color}`}>
                      {engagement?.label}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {data?.length === 0 && (
        <div className="text-center py-8">
          <Icon name="BarChart" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-3 opacity-50" />
          <p className="caption text-sm text-muted-foreground">No page engagement data available</p>
        </div>
      )}
    </div>
  );
};

export default PageEngagementTable;
